import { Eye, PencilSimple } from "@magnetic/icons";
import { Text } from "@magnetic/text";

import { Button } from "src/components/buttons";
import { HFlex } from "src/components/hFlex";
import { withShowToggle } from "src/components/hoc/withShowToggle";

import { ButtonProps } from "./types";

export const SwitchToEdit = withShowToggle(({ handleAction }: ButtonProps) => {
  return (
    <HFlex align="center" justify="center" gap="sm">
      <Text className="candidate-mode-text">Running mode</Text>
      <HFlex
        align="center"
        justify="center"
        gap="xs"
        className="action-buttons"
      >
        <Button
          name="edit-mode-button"
          kind="primary"
          onClick={handleAction}
          title="Switch to edit mode"
        >
          <PencilSimple />
        </Button>
        <Button
          name="disabled-running-mode-button"
          kind="secondary"
          disabled={true}
        >
          <Eye />
        </Button>
      </HFlex>
    </HFlex>
  );
});
